// extracted by mini-css-extract-plugin
module.exports = {"limitMessage":"textCounter__limitMessage___2T6oH"};